<template>
    <div id="plaid-page">
        <card title="Plaid Link">

            <b-row>
                <b-col>
                    {{ linkToken }}
                </b-col>
            </b-row>

            <b-row v-if="haveToken">
                <b-col>
                    <plaid-link :token="linkToken" :onLoad="onLoad" :onExit="onExit" :onEvent="onEvent"
                        :onSuccess="onSuccess">
                        Open Plaid Link
                    </plaid-link>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-button @click="linkToPlaid" :disabled="haveToken" variant="primary">Link</b-button>
                </b-col>
            </b-row>

        </card>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import PlaidLink from "vue-plaid-link";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";


@Component({
    name: "PlaidPage",
    components: {
        PlaidLink,
    }
})
export default class PlaidPage extends Vue {

    private linkToken: string = "";
    private patientId: number = 3003;

    async mounted() {
        try {
            let linkInfo = await axios.get(`/api/Plaid/Link/Info`);
            console.log("resp: ", linkInfo.data);

            let linkTokenResponse = await axios.get(`api/Plaid/Link/Token/${this.patientId}`);
            let linkToken = linkTokenResponse.data;
            console.log("linkToken: ", linkToken);
            let token = linkToken.link_token;
            console.log("token: ", token);
            this.linkToken = token;
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    get haveToken(): boolean {
        return this.linkToken != "";
    }

    onLoad(...args: any) {
        console.log("args: ", args);
    }

    onExit(...args: any) {
        console.log("args: ", args);
    }

    onEvent(...args: any) {
        console.log("args: ", args);
    }

    async onSuccess(token: string) {
        try {
            console.log("onSuccess token: ", token);
            let resp = await axios.post(`api/Plaid/Link/Token`, { publicToken: token, patientId: this.patientId });
            console.log("success response: ", resp.data);
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    linkToPlaid() {

    }
}
</script>

<style scoped></style>
